"use client";

import Link, { LinkProps } from "next/link";
import { useParams } from "next/navigation";
import { DEFAULT_COUNTRY_CODE } from "@/lib/constants";

interface CountryLinkProps extends LinkProps {
  children: React.ReactNode;
  href: string;
}

export function CountryLink({ children, href, ...props }: CountryLinkProps) {
  const { countryCode } = useParams<{ countryCode: string }>();

  // console.log(countryCode);

  const cleanHref = href.startsWith("/") ? href : `/${href}`;
  const localizedPath = `/${countryCode || DEFAULT_COUNTRY_CODE}${cleanHref}`;

  return (
    <Link {...props} href={localizedPath}>
      {children}
    </Link>
  );
}
